import styled from 'styled-components';
import { tokens } from '../design/tokens';

export const SocialForm = styled.form`
  padding: ${tokens.spacing.lg};

  @media (max-width: 768px) {
    padding: ${tokens.spacing.md};
  }
`;

export const FormGroup = styled.div`
  margin-bottom: ${tokens.spacing.xl};

  @media (max-width: 768px) {
    margin-bottom: ${tokens.spacing.lg};
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin-bottom: ${tokens.spacing.sm};
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const FormInput = styled.input`
  width: 100%;
  padding: ${tokens.spacing.md};
  border: 1px solid ${tokens.colors.adminBorder};
  border-radius: 6px;
  font-size: 14px;
  background: ${tokens.colors.adminSurface};
  color: ${tokens.colors.adminText};
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: ${tokens.colors.adminAccent};
    box-shadow: 0 0 0 3px ${tokens.colors.adminAccent}20;
  }

  &::placeholder {
    color: ${tokens.colors.adminTextMuted};
  }

  @media (max-width: 768px) {
    padding: ${tokens.spacing.sm};
    font-size: 16px; /* Prevent zoom on iOS */
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: ${tokens.spacing.md};
  justify-content: flex-end;
  margin-top: ${tokens.spacing.xl};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: ${tokens.spacing.sm};
  }
`;

export const SaveBtn = styled.button`
  background: ${tokens.colors.adminAccent};
  color: white;
  border: none;
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.sm};
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  min-height: 44px; /* Better touch target */

  &:hover {
    background: #7a04b8;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: ${tokens.spacing.md};
  }
`;

export const CancelBtn = styled.button`
  background: transparent;
  color: ${tokens.colors.adminText};
  border: 1px solid ${tokens.colors.adminBorder};
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.sm};
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  min-height: 44px;

  &:hover {
    background: ${tokens.colors.adminBorder};
    border-color: ${tokens.colors.adminText};
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: ${tokens.spacing.md};
  }
`;
